import {
  Field as IField,
  FieldGroup as IFieldGroup,
  OutputArrayTypes,
  SECTION_BREAK,
  SECTION_BREAK_SMALL,
} from "@/core/types/types";
import Field from "../../Field";
import NavigationButtons from "./NavigationButtons";
import FieldGroup from "./FieldGroup";
import { Box } from "@mui/material";

interface FormLayerProps {
  fields: (IField | IFieldGroup)[];
}

const FormLayer = ({ fields }: FormLayerProps) => {
  return (
    <>
      {fields.map((field: IField | IFieldGroup, idx: number) => {
        const groupItems: IField[] | undefined = (field as IFieldGroup)[
          OutputArrayTypes.FieldGroup
        ];
        const buttons: IField[] | undefined = (field as IFieldGroup)[
          OutputArrayTypes.Navigation
        ];
        const isSectionBreak: boolean = !!(field as IField).properties?.[
          SECTION_BREAK
        ];
        const isSmallSectionBreak: boolean = !!(field as IField).properties?.[
          SECTION_BREAK_SMALL
        ];
        return (
          <Box
            key={idx}
            mt={2}
            mb={isSectionBreak ? 4 : isSmallSectionBreak ? 3 : 0}
          >
            {typeof groupItems !== "undefined" && (
              <FieldGroup groupItems={groupItems} />
            )}
            {typeof buttons !== "undefined" && (
              <NavigationButtons buttons={buttons} />
            )}
            <Field field={field as IField} />
          </Box>
        );
      })}
    </>
  );
};

export default FormLayer;
